import { Component, ErrorInfo, ReactNode } from 'react'
import { logger } from '@/utils/logging'

interface Props {
  children: ReactNode
  FallbackComponent?: React.ComponentType
}

interface State {
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
  }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger().error(
      'React ErrorBoundary caught an error',
      {
        errorInfo,
        pathname: window?.location?.pathname,
      },
      error,
    )
  }

  render() {
    const { hasError } = this.state
    const { FallbackComponent, children } = this.props

    if (hasError) {
      return FallbackComponent ? <FallbackComponent /> : <h2>Oops, something went wrong.</h2>
    }

    return children
  }
}

export { ErrorBoundary }
